import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="ingredient-import-list"
export default class extends Controller {
  static values = { supplierValidated: Boolean };

  connect() {
    document.addEventListener("turbo:frame-render", this.handleFrameRender);
    console.log("ingredient-import-list controller connected", {
      supplierValidated: this.supplierValidatedValue,
    });

    // Only auto-scroll to first ingredient if supplier is already validated
    if (this.supplierValidatedValue) {
      this.scrollToFirstIngredient();
    }
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.handleFrameRender);
    console.log("ingredient-import-list controller disconnected");
  }

  scrollToFirstIngredient() {
    // Wait a bit for the page to be fully rendered
    setTimeout(() => {
      const firstIngredientFrame = this.element.querySelector(
        'turbo-frame[id^="ingredient_line_item_"]'
      );
      if (firstIngredientFrame) {
        firstIngredientFrame.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        console.log(
          "Auto-scrolled to first ingredient (supplier already validated)"
        );
      }
    }, 500);
  }

  handleFrameRender = (event) => {
    // The frame that was just rendered
    const replacedFrame = event.target;
    console.log("turbo:frame-render event fired", replacedFrame);
    if (!replacedFrame.id.startsWith("ingredient_line_item_")) {
      console.log(
        "Frame replaced is not an ingredient line item frame",
        replacedFrame.id
      );
      return;
    }

    // Find all ingredient line item frames in order
    const frames = Array.from(
      this.element.querySelectorAll('turbo-frame[id^="ingredient_line_item_"]')
    );
    console.log(
      "All ingredient frames:",
      frames.map((f) => f.id)
    );
    const currentIndex = frames.findIndex((f) => f.id === replacedFrame.id);
    console.log("Current frame index:", currentIndex);
    if (currentIndex === -1) return;

    // Find the next frame that is not already configured (i.e., still has a form)
    for (let i = currentIndex + 1; i < frames.length; i++) {
      const frame = frames[i];
      const input = frame.querySelector(
        "input:not([type=hidden]):not([disabled]), select, textarea"
      );
      console.log(`Checking frame ${frame.id} for focusable input:`, input);
      if (input) {
        input.focus();
        frame.scrollIntoView({ behavior: "smooth", block: "center" });
        console.log(`Focused and scrolled to input in frame ${frame.id}`);
        break;
      }
    }
  };
}
